/**
 * Legacy scrolling feed (FeedList cards). Off in production; enable locally for QA.
 * Set `VITE_ENABLE_TRADITIONAL_FEED=true` in `.env` to expose sidebar/settings toggles.
 */
export const TRADITIONAL_FEED_ENABLED =
  import.meta.env.VITE_ENABLE_TRADITIONAL_FEED === "true" ||
  import.meta.env.VITE_ENABLE_TRADITIONAL_FEED === "1";
